import { FormEvent } from 'react'
import { SavedView } from '../../shared/types'
import { useSavedViewCreate, useSavedViewRemove, useSavedViewUpdate } from '../api/saved-views'
import { Button } from './button'
import { Dialog, DialogFooter } from './dialog'
import { Input } from './input'

export function UpdateViewModal<Filter = unknown>({
	object,
	onClose,
	onSubmit = onClose,
	view,
	filter = view.filter,
}: {
	object: string
	onClose: VoidFunction
	onSubmit?: (filter: Filter) => void
	view: SavedView
	filter?: Filter
}) {
	const { mutate: updateView, isPending: isUpdating } = useSavedViewUpdate(object, view.id)
	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		updateView(
			{
				name: (e.currentTarget.elements.namedItem('name') as HTMLInputElement).value,
				filter,
			},
			{
				onSuccess: ({ id, filter }) => {
					onSubmit?.({ ...filter, viewId: id })
					onClose()
				},
			},
		)
	}

	return (
		<Dialog heading="Upravit pohled" isOpen onOpenChange={onClose}>
			<form onSubmit={handleSubmit}>
				<div className="p-4">
					<Input label="Název" name="name" defaultValue={view.name ?? ''} />
				</div>
				<DialogFooter>
					<Button type="submit" isPending={isUpdating}>
						Uložit
					</Button>
				</DialogFooter>
			</form>
		</Dialog>
	)
}

export function CreateViewModal<Filter = unknown>({
	object,
	onClose,
	onSubmit,
	filter,
}: {
	object: string
	onClose: VoidFunction
	onSubmit: (filter: Filter) => void
	filter: Filter
}) {
	const { mutate: createView, isPending: isCreating } = useSavedViewCreate(object)
	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		createView(
			{
				name: (e.currentTarget.elements.namedItem('name') as HTMLInputElement).value,
				filter,
			},
			{
				onSuccess: ({ id, filter }) => {
					onSubmit({ ...filter, viewId: id })
					onClose()
				},
			},
		)
	}

	return (
		<Dialog heading="Upravit pohled" isOpen onOpenChange={onClose}>
			<form onSubmit={handleSubmit}>
				<div className="p-4">
					<Input label="Název" name="name" defaultValue={''} />
				</div>
				<DialogFooter>
					<Button type="submit" isPending={isCreating}>
						Uložit
					</Button>
				</DialogFooter>
			</form>
		</Dialog>
	)
}

export function RemoveViewModal({
	onClose,
	object,
	view,
}: {
	onClose: VoidFunction
	object: string
	view: SavedView
}) {
	const { mutate: removeView, isPending: isRemoving } = useSavedViewRemove(object)
	const handleSubmit = () => {
		removeView(view.id, {
			onSuccess: onClose,
		})
	}

	return (
		<Dialog heading="Smazat pohled" isOpen onOpenChange={onClose}>
			<p className="p-4">Opravdu chcete smazat pohled?</p>
			<DialogFooter>
				<Button onPress={handleSubmit} isPending={isRemoving}>
					Potvrdit
				</Button>
				<Button onPress={onClose} variant="SECONDARY">
					Zrušit
				</Button>
			</DialogFooter>
		</Dialog>
	)
}
